module.exports = __webpack_public_path__ + "menu.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/menu.svg?color1=%233F51B5&color2=
// module id = 2204
// module chunks = 67